import {
  type ControlCardInstanceRemoveOverrideValidationResultInput,
  RemoveOverrideControlCardValidationResultDocument,
  type ValueInstanceFragment
} from "app/gql/graphqlSchema";
import {query} from "app/gql/client";
import {useCallback} from "react";
import {useLoadingContext} from "app/employee/LoadingContext";
import {useControlCardInstanceContext} from "app/employee/controlCard/ControlCardInstanceContext";

const removeOverrideControlCardValidationResultApi = async (
  input: ControlCardInstanceRemoveOverrideValidationResultInput
) => {
  const result = await query(RemoveOverrideControlCardValidationResultDocument, {input});
  return result.controlCardInstanceRemoveOverrideValidationResult;
};

export const useRemoveOverrideControlCardValidationResult = (valueInstance: Pick<ValueInstanceFragment, "id">) => {
  const {instance, updateValues} = useControlCardInstanceContext();

  const {startLoading, finishLoading, showExceptionError} = useLoadingContext();

  const removeOverrideValidationResult = useCallback(async () => {
    try {
      startLoading();
      const result = await removeOverrideControlCardValidationResultApi({
        instanceId: instance.id,
        valueIds: [valueInstance.id]
      });
      const updatedValues = result.values;
      updateValues(updatedValues);
    } catch (e) {
      await showExceptionError(e);
    } finally {
      finishLoading();
    }
  }, [finishLoading, instance.id, showExceptionError, startLoading, updateValues, valueInstance]);

  return {removeOverrideValidationResult};
};
